import Repository from './Repository';
import { MeasurementCategory } from '@/models/Measurement/MeasurementCategory';

const resource = '/Measurements';

export default {
    listServingSizeMeasurements() {
        return Repository.get(`${resource}/ListServingSizeMeasurements`, { withCredentials: true });
    },
    listMeasurementsForCategory(category: MeasurementCategory) {
        return Repository.post(`${resource}/ListMeasurementsForCategory`, { category: category }, { withCredentials: true });
    },
};
